export const MODULES = [
  // MEMBER
  {
    name: 'member',
    subs: [
      { name: '*' },
      { name: 'lookup' },
      { name: 'dashboard' },
      { name: 'transaction' },
      { name: 'communication' },
      { name: 'communication main nz' },
      { name: 'voucher' },
      { name: 'offer' },
      { name: 'notes' },
      { name: 'membership' },
      { name: 'membership subway' },
      { name: 'identification' },
      { name: 'identification hampsta' },
      { name: 'identification generic' },
      { name: 'history' },
      { name: 'notes create' },
      { name: 'purchase' },
      { name: 'purchase reversal' },
      { name: 'purchase redemption' },
      { name: 'purchase redemption reversal' },
      { name: 'loyalty redemption' },
      { name: 'loyalty redemption reversal' },
      { name: 'loyalty allocation' },
      { name: 'loyalty allocation reversal' },
      { name: 'icash topup' },
      { name: 'icash topup reversal' },
      { name: 'icash redemption' },
      { name: 'icash redemption reversal' },
      { name: 'icash donation' },
      { name: 'icash donation refund' },
      { name: 'credit allocation' },
      { name: 'credit allocation refund' },
      { name: 'send email for password reset' },
      { name: 'save to pdf' },
      { name: 'update status' },
      { name: 'update member details' },
      { name: 'update member details generic' },
      { name: 'bank accounts' },
      { name: 'direct payments' },
    ],
    access: {
      status: [
        { status: 'registered', subs: [{ name: '*' }] },
        { status: 'cancelled', subs: [{ name: '*' }] },
        { status: 'suspended', subs: [{ name: '*' }] },
        { status: 'unregistered', subs: [{ name: '*' }] },
      ],
    },
  },
  // SUBSQUAD
  {
    name: 'subsquad',
    subs: [{ name: '*' }, { name: 'lookup' }, { name: 'member' }],
    access: {
      status: [],
    },
  },
  // MERCHANT
  {
    name: 'merchant',
    subs: [
      { name: '*' },
      { name: 'lookup' },
      { name: 'transaction' },
      { name: 'identification' },
      { name: 'identification create' },
      { name: 'device' },
      { name: 'device create' },
      { name: 'memberships' },
      { name: 'membership create' },
      { name: 'bank accounts' },
      { name: 'bank accounts create' },
      { name: 'update merchant profile' },
      { name: 'update merchant status' },
    ],
    access: {
      status: [
        { status: 'current', subs: [{ name: '*' }] },
        { status: 'terminated', subs: [] },
        { status: 'closed', subs: [{ name: 'update merchant status' }] },
      ],
    },
  },
  // CAMPAIGN
  {
    name: 'campaign',
    subs: [{ name: '*' }, { name: 'lookup' }],
    access: {
      status: [],
    },
  },
  // CAMPAIGN VOUCHER
  {
    name: 'voucher',
    subs: [{ name: '*' }, { name: 'lookup' }],
    access: {
      status: [],
    },
  },
  // REPORTS
  {
    name: 'reports',
    subs: [{ name: '*' }, { name: 'lookup' }],
    access: {
      status: [],
    },
  },
  // BULK TRANSACTIONS
  {
    name: 'bulk transactions',
    subs: [{ name: '*' }, { name: 'lookup' }],
    access: {
      status: [],
    },
  },
]
